import React from 'react';
import { motion } from 'framer-motion';
import boy_last from '../../../assets/images/behavioral_therapy/boy_last.jpg';
import { useMediaQuery } from 'react-responsive';
import GradientButton from '../../../components/atoms/GradientButton';

function OlderChildren() {
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' });

  return (
    <div className="w-full flex flex-col justify-between gap-4 sm:gap-10 max-w-[1200px] mx-auto px-4 md:px-10 py-10 md:py-20 relative z-10">
      <div className="flex flex-col md:flex-row justify-between w-full gap-4 sm:gap-10 xl:gap-16">
        <div className="flex flex-1 flex-col gap-4 text-left text-primary text-[18px] sm:text-[24px] md:text-[35px] font-bold">
          <p>
            <span className="">
              Older children and adolescents may benefit from an evaluation if
              they:
            </span>
          </p>
          <ul className=" text-[18px] lg:text-[22px] font-[500] text-secondary pl-4 space-y-2 list-disc">
            <li>Have lost interest in things that they used to enjoy</li>
            <li>Have low energy</li>
            <li>
              Sleep too much or too little, or seem sleepy throughout the day
            </li>
            <li>
              Are spending more and more time alone, and avoid social activities
              with friends or family
            </li>
            <li>Diet or exercise excessively, or fear gaining weight</li>
            <li>
              Engage in self-harm behaviors (such as cutting or burning their
              skin)
            </li>
            <li>Smoke, drink alcohol, or use drugs</li>
            <li>
              Engage in risky or destructive behavior alone or with friends
            </li>
            <li>Have thoughts of suicide</li>
            <li>
              Have periods of highly elevated energy and activity, and require
              much less sleep than usual
            </li>
            <li>
              Say that they think someone is trying to control their mind or
              that they hear things that other people cannot hear.
            </li>
          </ul>
        </div>

        <div className="flex-1 flex justify-center lg:justify-end items-end relative">
          <motion.div
            initial={{ opacity: 0, x: isMobile ? 0 : 300 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.9, ease: 'easeOut' }}
            viewport={{ once: true, amount: 0.5 }}
          >
            <img
              className="rounded-3xl"
              src={boy_last}
              alt="older child therapy session"
            />
          </motion.div>
        </div>
      </div>
      <p className="text-[18px] lg:text-[24px] font-bold text-center pt-6">
        <span className="text-primary italic">
          If you’re interested mental health support or <br />
          pediatric behavioral therapy or have any questions, please
        </span>
      </p>

      <div className="flex flex-wrap flex-col md:flex-row items-center justify-center gap-5">
        <GradientButton
          text="Contact us"
          width="w-[250px]"
          navigateTo={'/contact'}
        />
        <span className="text-secondary font-medium">or</span>
        <GradientButton
          text="Schedule an Evaluation"
          width="w-[250px]"
          navigateTo={'/contact'}
        />
      </div>
    </div>
  );
}

export default OlderChildren;
